import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import AbpBase from '../lib/AbpBase';
var TenantSwitch = /** @class */ (function (_super) {
    __extends(TenantSwitch, _super);
    function TenantSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changedTenancyName = '';
        return _this;
    }
    Object.defineProperty(TenantSwitch.prototype, "tenant", {
        get: function () {
            return this.$store.state.session.tenant;
        },
        enumerable: true,
        configurable: true
    });
    TenantSwitch.prototype.cancel = function () {
        this.$emit('input', false);
    };
    TenantSwitch.prototype.visibleChange = function (value) {
        if (!value) {
            this.$emit('input', value);
        }
        else {
            this.changedTenancyName = this.$store.state.session.tenant ? this.$store.state.session.tenant.name : '';
        }
    };
    TenantSwitch.prototype.changeTenant = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tenant;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.changedTenancyName) return [3 /*break*/, 1];
                        abp.multiTenancy.setTenantIdCookie(undefined);
                        ;
                        location.reload();
                        return [2 /*return*/];
                    case 1: return [4 /*yield*/, this.$store.dispatch({
                            type: 'account/isTenantAvailable',
                            data: { tenancyName: this.changedTenancyName }
                        })];
                    case 2:
                        tenant = _a.sent();
                        switch (tenant.state) {
                            case 1:
                                abp.multiTenancy.setTenantIdCookie(tenant.tenantId);
                                location.reload();
                                return [2 /*return*/];
                            case 2:
                                this.$Modal.error({ title: this.L('Error'), content: this.L('TenantIsNotActive') });
                                break;
                            case 3:
                                this.$Modal.error({ title: this.L('Error'), content: this.L('ThereIsNoTenantDefinedWithName{0}', undefined, this.changedTenancyName) });
                                break;
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({ default: false })
    ], TenantSwitch.prototype, "value", void 0);
    TenantSwitch = __decorate([
        Component
    ], TenantSwitch);
    return TenantSwitch;
}(AbpBase));
export default TenantSwitch;
